import { render, staticRenderFns } from "./EnterMarksLessonAdmin.vue?vue&type=template&id=04b5ca7f&scoped=true"
import script from "./EnterMarksLessonAdmin.vue?vue&type=script&lang=js"
export * from "./EnterMarksLessonAdmin.vue?vue&type=script&lang=js"
import style0 from "./EnterMarksLessonAdmin.vue?vue&type=style&index=0&id=04b5ca7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b5ca7f",
  null
  
)

export default component.exports